module.exports = __webpack_public_path__ + "static/img/6.2510710.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tx/6.jpg
// module id = 5Swb
// module chunks = 0